import { jsx as _jsx } from "react/jsx-runtime";
import { Chip, Tooltip } from '@mui/material';
import { getColorAndBackground } from '../../../constants/helper';
export const CustomChip = ({ value, size = 'small', icon }) => {
    const { color, background } = getColorAndBackground(value);
    return (_jsx(Tooltip, { title: value, children: _jsx(Chip, { icon: icon, label: value, size: size, style: {
                color: color,
                borderRadius: '25px',
                background: background,
                fontWeight: 600
            } }) }));
};
